import Image from './image/Image';
import styles from './rounded-image.module.less';

const RoundedImage = ({ size = '60px', src, className = '', showDefault = true, loading, alt = '', onError, role }) => {
    if (!src && !showDefault) {
        return (
            <div
                className={[styles.container, className].join(' ')}
                style={{
                    flexBasis: size,
                    height: size,
                    width: size,
                }}
            ></div>
        );
    }

    return (
        <div
            className={[styles.container, className].join(' ')}
            style={{
                flexBasis: size,
                height: size,
                width: size,
            }}
        >
            <Image
                src={src || 'default-user-image.svg'}
                alt={alt}
                role={role}
                className={styles.image}
                loading={loading}
                onError={onError}
            />
        </div>
    );
};

export default RoundedImage;
